import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ palette, spacing }) => ({
  container: {
    fontSize: '3rem',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',
    boxShadow: 'none',
    padding: 0,
    paddingTop: spacing(4),
    margin: 0,

    '& .MuiTypography-root': {
      fontWeight: '500',
    },
  },
  userList: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: spacing(8),
  },
  title: {
    color: palette.gray[32],
    marginBottom: spacing(6),
  },
  button: {
    height: spacing(40),
    fontWeight: 'normal',
    fontSize: '16px',

    '&:hover': {
      border: 0,
      backgroundColor: 'none',
    },
  },
  subTitle: {
    fontSize: '12px',
    paddingLeft: 0,
    marginLeft: 0,
    textAlign: 'left',
  },
}))
